// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Navigation, Scrollbar, FreeMode, Mousewheel} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
// import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/free-mode';
export default function initializeSwipers(element) {
    setImagesSlider();
}

function setImagesSlider() {

    var horizontalDrag = new Swiper(".js-drag-horizontal", {
        modules: [FreeMode, Mousewheel],
        slidesPerView: 5,
        freeMode: true,
        spaceBetween: 10,
        mousewheel: true,
    });

    var swiper = new Swiper(".mySwiper", {
        modules: [Navigation, Scrollbar],
        centeredSlides: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        scrollbar: {
            el: '.swiper-custom-scrollbar',
            draggable: true
        },
        navigation: {
            prevEl: ".js--swiper-custom-button-prev",
            nextEl: ".js--swiper-custom-button-next",
        },
        breakpoints: {
            768: {
                centeredSlides: true,
                slidesPerView: 2.8,
                spaceBetween: 30,
            },
            1024: {
                centeredSlides: false,
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1200: {
                centeredSlides: false,
                slidesPerView: 4,
                spaceBetween: 20,
            }
        }
    });
    let sliders = document.querySelectorAll(".homeBalloonSlider");
    sliders.forEach(slider => {
        const swiper = new Swiper(slider, {
            modules: [Navigation, Scrollbar],
            loop: true,
            slidesPerView: 1.2,
            spaceBetween: 20,
            scrollbar: {
                el: '.swiper-custom-scrollbar',
                draggable: true
            },
            navigation: {
                prevEl: ".js--swiper-custom-button-prev",
                nextEl: ".js--swiper-custom-button-next",
            },
            breakpoints: {
                768: {
                    loop: true,
                    slidesPerView: 2.8,
                    spaceBetween: 30,
                },
                1024: {
                    centeredSlides: false,
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1200: {
                    centeredSlides: false,
                    slidesPerView: 4,
                    spaceBetween: 20,
                }
            }
        });
    })

    let blockSliders = document.querySelectorAll(".blockSlider")
    blockSliders.forEach(slider => {
        // Find navigation buttons within this specific slider's parent container
        const container = slider.closest('.relative') || slider.parentElement;
        const prevButton = container.querySelector(".js--swiper-custom-button-prev");
        const nextButton = container.querySelector(".js--swiper-custom-button-next");

        const swiper = new Swiper(slider, {
            modules: [Navigation, Scrollbar],
            centeredSlides: true,
            slidesPerView: 1.3,
            spaceBetween: 10,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
            breakpoints: {
                768: {
                    centeredSlides: true,
                    slidesPerView: 2.8,
                    spaceBetween: 30,
                },
                1024: {
                    centeredSlides: false,
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                1200: {
                    centeredSlides: false,
                    slidesPerView: 1,
                    spaceBetween: 20,
                }
            }
        });
    })
}
